import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { Attractions } from "./pages/Attractions";
import { Events } from "./pages/Events";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { FAQ } from "./pages/FAQ";
import { Gallery } from "./pages/Gallery";
import { AdminDashboard } from "./pages/AdminDashboard";
import { openRollerBooking } from "./lib/roller";

function App() {
  // Every "Book Now" across the site deep-links to the Roller checkout.
  const handleBookNow = () => openRollerBooking();

  return (
    <div className="App">
      <BrowserRouter>
        <Header onBookNow={handleBookNow} />
        <Routes>
          <Route path="/" element={<Home onBookNow={handleBookNow} />} />
          <Route path="/attractions" element={<Attractions onBookNow={handleBookNow} />} />
          <Route path="/events" element={<Events onBookNow={handleBookNow} />} />
          <Route path="/about" element={<About onBookNow={handleBookNow} />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ onBookNow={handleBookNow} />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/admin" element={<AdminDashboard />} />
          {/* Legacy routes — Roller handles pricing & booking now. Redirect quietly. */}
          <Route path="/pricing" element={<Navigate to="/attractions" replace />} />
          <Route path="/book" element={<Navigate to="/attractions" replace />} />
          <Route path="/booking-success" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
